import React from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import { IAccountUser } from '../../../../models/account-user';
import { IOrderNotificationPreference } from '../../../../models/order-notification-preference';
import AccountItem from '../../../common/account-item';

interface IOrderPreferenceProps {
    preference: IOrderNotificationPreference;
    isReadOnly: boolean;
    users: IAccountUser[];
    onChange: (event: any) => void;
    onCopy: (pref: IOrderNotificationPreference) => void;
    showCopyAllButton: boolean;
}

const OrderPreferenceItem = ({
    preference,
    isReadOnly,
    users,
    onChange,
    onCopy,
    showCopyAllButton,
}: IOrderPreferenceProps) => {
    const intl = useIntl();
    const handleCopy = () => {
        onCopy(preference);
    };

    return (
        <div className="row">
            <AccountItem account={preference.shipToAccount} />
            <div className="col-md-6 form-group">
                <select
                    name="emailAddress"
                    aria-label="emailAddress"
                    className="form-control"
                    value={preference.emailAddress}
                    disabled={isReadOnly}
                    onChange={onChange}
                >
                    {!isReadOnly && (
                        <option value="">
                            {intl.formatMessage({
                                id: 'Select',
                            })}
                            &nbsp;...
                        </option>
                    )}
                    {users.map((u, i) => {
                        return u.lastName && u.firstName ? (
                            <option
                                key={u.directoryUser + i.toString()}
                                value={u.directoryUser}
                            >
                                {u.directoryUser +
                                    '  (' +
                                    u.lastName +
                                    ', ' +
                                    u.firstName +
                                    ')'}
                            </option>
                        ) : (
                            <option
                                key={u.directoryUser + i.toString()}
                                value={u.directoryUser}
                            >
                                {u.directoryUser}
                            </option>
                        );
                    })}
                </select>
            </div>
            <div className="col-md-2">
                <>
                    {showCopyAllButton && !isReadOnly && (
                        <button
                            name="copyButton"
                            aria-label="copy"
                            className="btn btn-default float-right"
                            onClick={handleCopy}
                            disabled={!preference.emailAddress}
                        >
                            <FormattedMessage
                                id="Copy_To_All"
                                defaultMessage="COPY TO ALL"
                            />
                        </button>
                    )}
                </>
            </div>
        </div>
    );
};

export default OrderPreferenceItem;
